export const ACTIVE_CLASS_NAME =
  "toggle-pages__page--active js-toggle-page--active";
export const ACTIVE_SELECTOR = "js-toggle-page--active";
